<template>
  <div>
    <el-form :inline="true" size="small">
      <el-form-item label="客户：">
        <el-input v-model="keyword" placeholder="客户姓名" clearable
                  style="width:160px"
                  @keyup.enter.native="load" />
      </el-form-item>
      <!--
        为什么要有这个筛选：列表按"主账号在前、子账号在后"排，生产有 500 个主账号，
        子账号要翻到第 26 页才出现 —— 用户看到摘要写着"子账号 87 人"、
        眼前却整页都是"否"，会以为这一列坏了（2026-09-18 就这么被报上来过）。
      -->
      <el-form-item label="账号类型：">
        <el-select v-model="subFilter" placeholder="全部" clearable
                   style="width:120px"
                   @change="pageNo = 1">
          <el-option label="仅主账号" :value="false" />
          <el-option label="仅子账号" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item label="统计时间：">
        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        style="width:270px" @change="load" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" @click="load">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
        <el-button type="primary" size="mini" plain :disabled="loading || queryFailed" @click="toExport">导出</el-button>
        <span class="summary">
          共 {{ all.length }} 人，其中子账号
          <!-- 点这个数字直接筛出来，省得翻 26 页 -->
          <a class="sub-link" @click="showSubOnly">{{ subCount }}</a> 人
          <a v-if="subFilter !== null" class="sub-link" @click="clearSubFilter">（清除筛选）</a>
        </span>
      </el-form-item>
    </el-form>
    <div v-if="queryFailed" class="range-tip">查询失败，请重试；当前数据未加载。</div>
    <div v-if="rangeMode" class="range-tip">统计区间：{{ appliedRange[0] }} 至 {{ appliedRange[1] }}。业绩与服务次数按所选区间统计，余额为当前实时值。</div>
    <div class="range-tip">扫码签到老师与时间默认显示本月记录；选择统计时间后，显示所选区间全部扫码签到记录。</div>
    <big-detail-table :rows="pageRows" :loading="loading" :range-mode="rangeMode" show-scan-sign-ins />
    <pagination v-show="filteredRows.length > 0" :total="filteredRows.length" :page-no="pageNo"
                :page-size="pageSize" @pagination="handlePagination" />
  </div>
</template>

<script>
import bigCustomerBoardApi from '@/api/count/bigCustomerBoard'
import Pagination from '@/components/Pagination'
import bigDetailTable from './bigDetailTable.vue'

/**
 * 「3.0 客户明细」（REQ-2026-107511）：全部大客户（含子账号）
 * 后端一次给全量（生产 587 行），这里本地分页；导出走导出记录页
 */
export default {
  components: { Pagination, bigDetailTable },
  data() {
    return {
      keyword: '',
      dateRange: [],
      appliedRange: [],
      appliedKeyword: '',
      requestId: 0,
      queryFailed: false,
      // null = 全部；true = 仅子账号；false = 仅主账号
      subFilter: null,
      all: [],
      loading: false,
      pageNo: 1,
      pageSize: 20
    }
  },
  computed: {
    rangeMode() { return this.appliedRange.length === 2 },
    // 摘要里的两个数一律按**全量**算、不跟着筛选变，否则筛"仅子账号"后
    // 会显示"共 87 人，其中子账号 87 人"，占比就看不出来了
    subCount() { return this.all.filter(r => r.isSub).length },
    filteredRows() {
      if (this.subFilter === null || this.subFilter === undefined || this.subFilter === '') {
        return this.all
      }
      return this.all.filter(r => !!r.isSub === this.subFilter)
    },
    pageRows() {
      const start = (this.pageNo - 1) * this.pageSize
      return this.filteredRows.slice(start, start + this.pageSize)
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    handlePagination({ pageNo, pageSize }) {
      this.pageNo = pageSize === this.pageSize ? pageNo : 1
      this.pageSize = pageSize
    },
    rangeParams(range) {
      return range && range.length === 2 ? { startDate: range[0], endDate: range[1] } : {}
    },
    reset() {
      this.keyword = ''
      this.dateRange = []
      this.subFilter = null
      this.load()
    },
    showSubOnly() {
      this.subFilter = true
      this.pageNo = 1
    },
    clearSubFilter() {
      this.subFilter = null
      this.pageNo = 1
    },
    load() {
      const requestId = ++this.requestId
      const range = (this.dateRange || []).slice()
      const keyword = this.keyword || undefined
      this.loading = true
      bigCustomerBoardApi.detail(keyword, this.rangeParams(range)).then(({ data }) => {
        if (requestId !== this.requestId) return
        this.all = data || []
        this.appliedRange = range
        this.appliedKeyword = keyword || ''
        this.queryFailed = false
        this.pageNo = 1
      }).catch(() => {
        if (requestId !== this.requestId) return
        this.all = []
        this.queryFailed = true
      }).finally(() => { if (requestId === this.requestId) this.loading = false })
    },
    toExport() {
      this.$router.push({ path: '/export/list', query: {
        code: 'EEForBigCustomerDetail', keyword: this.appliedKeyword || undefined,
        ...this.rangeParams(this.appliedRange)
      } })
    }
  }
}
</script>

<style scoped>
.summary {
  margin-left: 12px;
  color: #909399;
  font-size: 13px;
}
.sub-link {
  color: #409EFF;
  cursor: pointer;
}
.range-tip { margin-bottom: 10px; color: #606266; }
</style>
